import React from "react"
import Header from "./header"

export default function Layout({ children }) {
  return (
    <>
      <Header />
      <section className="section">
        <div className="container is-max-desktop">
          {children}
        </div>
      </section>
    </>
  )
}